
$('.my-invoices, .my-invoice').on('click', 'a[data-download-invoice]', function (e) {

    e.preventDefault();

    // console.log('click');

    // console.log($(this));

    var btn = $(this);

    btn.addClass('loading');

    pd = new FormData();
    pd.append('action', 'display_user_invoice');
    pd.append('invoice-id', btn.data('download-invoice'));

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            btn.removeClass('loading');

            // console.log(response);

            if(response.success) {
                // window.open("data:application/pdf," + response.data);

                var a = document.createElement('a');
                a.href= "data:application/octet-stream;base64;charset=utf-8,"+ response.data.content;
                a.target = '_blank';
                a.download = response.data.name;
                a.click();
            }
        }
    })

});